const STORAGE_KEY = 'theme';

export function isDarkMode() {
    return document.documentElement.classList.contains('dark');
}

export function setDarkMode(dark) {
    document.documentElement.classList.toggle('dark', dark);
    try {
        localStorage.setItem(STORAGE_KEY, dark ? 'dark' : 'light');
    } catch (e) {
        // localStorage unavailable (private mode, etc.), ignore
    }
}

export function toggleDarkMode() {
    setDarkMode(!isDarkMode());
    return isDarkMode();
}
